{
  "title": "Material Requests",
  "subtitle": "Internal requisitions raised for picking against warehouse stock.",
  "add": "New Material Request",
  "edit": "Edit",
  "generatePickList": "Generate Pick List",
  "table": {
    "number": "MR Number",
    "warehouse": "Warehouse",
    "requestedBy": "Requested By",
    "date": "Date",
    "lines": "Lines",
    "status": "Status",
    "client": "Client"
  },
  "form": {
    "warehouse": "Warehouse",
    "client": "Client",
    "material": "Material",
    "quantity": "Quantity",
    "addLine": "Add Line",
    "modeManual": "Manual",
    "modeExcel": "Excel Import",
    "excelHint": "Download the template, fill in Material Code and Qty for each material you need, then upload it — the parsed rows appear below for review before saving.",
    "downloadTemplate": "Download Template",
    "uploadFile": "Upload Filled Template",
    "excelRowMaterialNotFound": "Row {{row}}: material code '{{code}}' was not found.",
    "excelRowInvalidQty": "Row {{row}}: '{{code}}' needs a quantity greater than zero."
  },
  "save": "Save",
  "cancel": "Cancel"
}
